exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins);", ""]);

// Module
exports.push([module.id, ".TotalWokUnits-module__topInfoBox__1GyJ2 {\n  min-width: 80px;\n  max-width: 150px;\n  padding: 0px;\n  border-radius: 7px;\n  line-height: 12px;\n  font-size: 10px;\n}\n.TotalWokUnits-module__infoicons__24PZp {\n  float: right;\n  margin: -2px 10px 0px 0px;\n  font-size: 16px;\n  color: #707683;\n}\n.TotalWokUnits-module__h1_weight__1ZF4x {\n  font-weight: 700;\n}\n.TotalWokUnits-module__border__3klIX {\n  border-right: 2px solid #c4c4c4;\n}\n:root {\n  --status-color-complete: #ffffff;\n  --status-color-aborted: #d1d0ce;\n  --status-color-queued: #ffc;\n  --status-color-error: #ffd5d5;\n  --status-color-executing: #efe;\n  --status-color-default: #f5f5f5;\n}\n", ""]);

// Exports
exports.locals = {
	"topInfoBox": "TotalWokUnits-module__topInfoBox__1GyJ2",
	"infoicons": "TotalWokUnits-module__infoicons__24PZp",
	"h1_weight": "TotalWokUnits-module__h1_weight__1ZF4x",
	"border": "TotalWokUnits-module__border__3klIX"
};